export const TRANSLATIONS_EN_SHELL_AND_COMMON = {
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all as read",
  "header.help": "Help",
  "header.theme.switchToLight": "Switch to light theme",
  "header.theme.switchToDark": "Switch to dark theme",
  "role.admin": "Admin",
  "role.user": "User",
  "navbar.brand": "RAG System",
  "nav.home": "Home",
  "nav.expandSidebar": "Expand sidebar",
  "nav.collapseSidebar": "Collapse sidebar",
  "nav.notifications": "Notifications",
  "nav.userMenu": "User menu",
  "nav.help": "Help",
  "nav.chat": "Chat",
  "nav.upload": "Upload Documents",
  "nav.dashboard": "Dashboard",
  "nav.profile": "Profile",
  "nav.settings": "Preferences",
  "nav.logout": "Logout",
  "nav.query": "Query",
  "nav.about": "About",
  "nav.tasks": "Tasks",
  "nav.plan": "Plan",
  "plan.tabs.overview": "My plan",
  "plan.tabs.detail": "Details",
  "nav.usage": "My plan",
  " ": "Double click to download",
  "breadcrumbs.input.label": "File Location",
  "breadcrumbs.popover.create_option": "Create folder",
  "breadcrumbs.modal.label": "Folder Name",
  "breadcrumbs.modal.button.cancel": "Cancel",
  "breadcrumbs.modal.button.create": "Create",
  "common.close": "Close",
  "common.options": "Options",
  "common.cancel": "Cancel",
  "nav.documents": "Documents",
  "auth.login": "Login",
  "auth.or": "or",
  "auth.signup": "Sign Up",
  "auth.powered_by": "Powered by",
  "footer.rights": "All rights reserved.",
  "footer.terms": "Terms of Service",
  "footer.privacy": "Privacy Policy",
  "footer.contact": "Contact",
  "auth.create_account": "Create account",
  "auth.signup_description": "Create an account to get started",
  "auth.back_to_login": "Back to login",
  "auth.loading": "Loading...",
  "auth.redirecting": "Redirecting...",
  "nav.admin": "Admin",
  "notifications.empty": "No notifications",
  "role.executive": "Executive",
  "common.yes": "Yes",
  "common.no": "No",
  "common.save": "Save",
  "common.email": "Email",
  "common.role": "Role",
  "common.created": "Created",
  "common.actions": "Actions",
  "common.page": "Page",
  "common.of": "of",
  "common.prev": "Previous",
  "common.next": "Next",
  "common.status": "Status",
  "common.name": "Name",
  "common.records": "records",
  "common.inactive": "Inactive",
  "common.activate": "Activate",
  "common.deactivate": "Deactivate",
  "common.sending": "Sending...",
  "errors.email_required": "Email is required.",
  "errors.email_invalid": "Invalid email format.",
  "errors.role_required": "Role is required.",
  "nav.generate": "Generated Documents",
  "nav.knowledge": "Knowledge",
  "nav.changes": "Changes",
  "nav.alerts": "Alerts",
  "nav.knowledgeHub": "Knowledge Hub",
};
